import BaseService from '_services/rest/base';

class CustomerService extends BaseService {
  constructor() {
    super();
  }

  deleteCustomer(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/customer`;
  }

  getUrlAddress(id, addressId = null) {
    if (addressId) {
      return {
        url: `${this.getUrl()}/${id}/address/${addressId}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${id}/address`,
      method: 'POST',
    };
  }

  getUrlContact(id, contactId) {
    if (contactId) {
      return {
        url: `${this.getUrl()}/${id}/contact/${contactId}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${id}/contact`,
      method: 'POST',
    };
  }

  getUrlSave(id) {
    if (id) {
      return {
        url: `${this.getUrl()}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}`,
      method: 'POST',
    };
  }

  getCustomerById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  prepareRequestSaveAddress(customerId, addresses) {
    addresses.map(address => this.saveAddress(customerId, address));
  }

  removeAddress(id, addressId) {
    return this.request(`${this.getUrl()}/${id}/address/${addressId}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(customer) {
    const meta = this.getUrlSave(customer.id);
    return this.request(meta.url, customer, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveAddress(id, address) {
    const meta = this.getUrlAddress(id, address.id);
    return this.request(meta.url, address, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveContact(id, contact) {
    const meta = this.getUrlContact(id, contact.id);
    return this.request(meta.url, contact, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  uploadFile(params) {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('name', params.name);
    return this.request(`${this.getUrl()}/${params.id}/file`, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteFile(params) {
    return this.request(`${this.getUrl()}/${params.customerId}/file/${params.fileId}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getFiles(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/${params.customerId}/files`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  downloadMultipleFiles(customerId, fileIds) {
    return this.request(`${this.getUrl()}/${customerId}/files/download-multiple`, { file_ids: fileIds }, 'POST', 'blob')
      .catch(err => {
        throw err;
      });
  }

  sendEmailNewFilesUpload(customerId, params) {
    return this.request(`${this.getUrl()}/${customerId}/send/email`, params, 'POST')
      .catch(err => {
        throw err;
      });
  }
}

export default new CustomerService();
